export default {
    'checked': 'Checked'
};
